import { useMemo } from "react";
const noop = () => void 0;
function useValidateOn(validate, validateOn) {
  return useMemo(() => {
    return {
      validateOnBlur: validateOn?.includes("blur") ? validate : noop,
      validateOnFocus: validateOn?.includes("focus") ? validate : noop,
      validateOnChange: validateOn?.includes("change") ? validate : noop
    };
  }, [validate, validateOn]);
}
export {
  useValidateOn
};
//# sourceMappingURL=useValidateOn.js.map
